import { render } from "./CommunLoc.vue?vue&type=template&id=535cf1c7"
import script from "./CommunLoc.vue?vue&type=script&lang=js"
export * from "./CommunLoc.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__